import type { User } from "firebase/auth";
import { onAuthStateChanged } from "firebase/auth";
import { create } from "zustand";
import { apiPost } from "./api";
import { auth } from "./firebase";

interface AuthState {
  fbUser: User | null;
  ready: boolean;
  setUser: (u: User | null) => void;
  setReady: (r: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  fbUser: null,
  ready: false,
  setUser: (u) => set({ fbUser: u }),
  setReady: (r) => set({ ready: r }),
}));

/**
 * Subscribe to Firebase auth state. On sign-in, sync the user to our DB.
 * Safe no-op when Firebase is not configured (auth === null). Call once at startup.
 */
export function initAuth(): void {
  if (!auth) {
    useAuthStore.getState().setReady(true);
    return;
  }
  onAuthStateChanged(auth, async (user) => {
    useAuthStore.getState().setUser(user);
    if (user) {
      try {
        await apiPost("/me/sync");
      } catch {
        // Non-fatal: profile fetch will surface errors in the UI.
      }
    }
    useAuthStore.getState().setReady(true);
  });
}
